import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import styles from './PrivacyPolicyPage.module.css';

const TERMLY_POLICY_ID = 'cde45d6e-6a45-4879-9350-74a0db9fe32c';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (document.getElementById('termly-jssdk')) return;

    const script = document.createElement('script');
    script.id = 'termly-jssdk';
    script.src = 'https://app.termly.io/embed-policy.min.js';
    script.async = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className={styles.container}>
      {/* Navigation */}
      <nav className={styles.nav}>
        <div className={styles.navContent}>
          <Link to="/" className={styles.logo}>
            <img src="/icons/autochef_logo.svg" alt="AutoChef" />
            <span>AutoChef</span>
          </Link>
          <div className={styles.navButtons}>
            <Link to="/signup" className={styles.navButton}>Start Free Trial</Link>
            <Link to="/login" className={styles.navButtonOutline}>Login</Link>
          </div>
        </div>
      </nav>

      {/* Privacy Policy - Termly Pro embed */}
      <main className={styles.main}>
        <div className={styles.policyContainer}>
          <div
            name="termly-embed"
            data-id={TERMLY_POLICY_ID}
          />
        </div>
      </main>

      {/* Footer */}
      <footer className={styles.footer}>
        <div className={styles.footerContent}>
          <div className={styles.footerBrand}>
            <img src="/icons/autochef_logo.svg" alt="AutoChef" />
            <span>AutoChef</span>
          </div>
          <div className={styles.footerLinks}>
            <Link to="/">Home</Link>
            <Link to="/privacy-policy">Privacy</Link>
            <Link to="/terms">Terms</Link>
          </div>
          <div className={styles.footerCopy}>
            © {new Date().getFullYear()} AutoChef. All rights reserved.
          </div>
        </div>
      </footer>
    </div>
  );
};

export default PrivacyPolicyPage;
